module.exports = "/_next/static/images/facebook@2x-9fc4812c0a1a64f278c0baa3311421d6.png";